<template>
  <div class="main d-flex flex-row justify-content-between" :style="cssProps">
    <div class="search-block d-flex flex-column align-items-center">
      <div class="up-block">
        <div class="search d-flex flex-row justify-content-start align-items-center">
          <i class="fal fa-search"></i>
          <input type="search" placeholder="Search for restaurants" @input="searchEnter" v-model="search">
        </div>
        <div class="buttons-location d-flex flex-row justify-content-around" v-if="!isSearched">
          <button class="d-flex flex-row justify-content-between" @click="isNearby = true" :class="{'active':isNearby}">
            <i class="fas fa-street-view"></i>
            <div class="d-flex flex-column">
              <h1>Nearby Places</h1>
              <span>Choose a restaurant that is very close to your current location.</span>
            </div>
          </button>
            <button class="d-flex flex-row justify-content-between" @click="isNearby = false" :class="{'active':!isNearby}"> 
              <i class="fal fa-globe-americas"></i>
              <div class="d-flex flex-column">
              <h1>All Restaurants</h1>
              <span>Choose a restaurant from the list of all available places.</span>
            </div>
            </button>
        </div>
      </div>
      <div class="down-block d-flex flex-column justify-content-center align-items-center" v-if="isNearby && nearbyRestaurants.length === 0 && !isSearched" :class="isNearby && nearbyRestaurants.length === 0 && !isSearched ? 'down-block-location' : ''">
        <i class="fal fa-street-view"></i>
        <h1 v-if="!locationIsDisabled">Find My Location</h1>
        <h1 v-else>Your Location Services Are Disabled</h1>
        <span v-if="!locationIsDisabled">Enable location services to automatically find the nearest restaurants. This will enhance your ordering experience.</span>
        <span v-else>In order to provide better service, please turn on your location service in your browser settings.</span>
        <button @click="geolocation">Turn On</button>
      </div>
      <div class="down-block d-flex flex-column justify-content-center align-items-center" v-else>
        <restaurant-view v-if="isSearched"
          :title="searchedRestaurants.length + ' restaurant found ' + search" 
          :viewedData="searchedRestaurants"
          @makeOrder="nextToOrder"
          @zoom="zoomMarker" >
        </restaurant-view>
        <restaurant-view v-else-if="!isNearby"
          :title="restaurants.length + ' available restaurants'" 
          :viewedData="restaurants"
          @makeOrder="nextToOrder"
          @zoom="zoomMarker" >
        </restaurant-view>
        <restaurant-view v-else
          :title="nearbyRestaurants.length + ' restaurants found near you'" 
          :viewedData="nearbyRestaurants"
          @makeOrder="nextToOrder"
          @zoom="zoomMarker" >
        </restaurant-view>
      </div>
    </div>
    
    <div class="map-block" v-show="!isNearby || isSearched || nearbyRestaurants.length > 0" transition="expand">
      <div id="googleMap" class="googleMaps"></div>
    </div>
   
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import restaurantView from './custom/restaurantView.vue'
export default {
  name: 'search',
  components:{
    restaurantView
  },
  data(){
    return{
      restaurants: [],
      nearbyRestaurants: [],
      searchedRestaurants: [],
      map: null,
      isNearby: true,
      locationIsDisabled: false,
      search: null,
      isSearched: false,
      markers: [],
      currentMarker: null,
      currentCircle: null,
      bigPin: `<svg width="60px" height="74px" viewBox="0 0 60 74" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>pin</title>
                  <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="index/detection" transform="translate(-838.000000, -335.000000)">
                          <g id="pin" transform="translate(838.000000, 335.000000)">
                              <path d="M38,59.0549288 C33.5000495,59.5523731 30,63.3674463 30,68 C30,63.3674463 26.4999505,59.5523731 22,59.0549288 L22,59 L22.2899933,59 C9.45748002,55.5972106 0,43.9030617 0,30 C0,13.4314575 13.4314575,0 30,0 C46.5685425,0 60,13.4314575 60,30 C60,43.9030617 50.54252,55.5972106 37.7100067,59 L38,59 L38,59.0549288 Z M30,74 C28.3431458,74 27,72.6568542 27,71 C27,69.3431458 28.3431458,68 30,68 C31.6568542,68 33,69.3431458 33,71 C33,72.6568542 31.6568542,74 30,74 Z" id="bg" fill="#c12d39"></path>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" width="20px" height="24px" x="20" y="20">
                                  <path d="M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z" fill="#FFFFFF"/>
                              </svg>
                          </g>
                      </g>
                  </g>
              </svg>`,
      pin: `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <desc>Created with Sketch.</desc>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-737.000000, -165.000000)">
                      <g id="pin" transform="translate(737.000000, 165.000000)">
                          <circle id="dot" fill="#C12D39" cx="12" cy="12" r="12"></circle>
                          <circle id="center" fill="#FFFFFF" cx="12" cy="12" r="4"></circle>
                      </g>
                  </g>
              </g>
          </svg>`,
      currentPin: `<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>current</title>
          <desc>Created with Sketch.</desc>
          <defs>
              <circle id="path-1" cx="128" cy="128" r="11"></circle>
              <filter x="-72.7%" y="-72.7%" width="245.5%" height="245.5%" filterUnits="objectBoundingBox" id="filter-2">
                  <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
          </defs>
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="index/detection" transform="translate(-886.000000, -428.000000)">
                  <g id="current" transform="translate(780.000000, 322.000000)">
                      <g id="Oval-Copy-2">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <circle stroke-opacity="0.05" stroke="#000000" stroke-width="1" fill-opacity="0.82" fill="#F8F8F8" fill-rule="evenodd" cx="128" cy="128" r="11.5"></circle>
                      </g>
                      <circle id="Oval-Copy" fill="#C12D39" cx="128" cy="128" r="7"></circle>
                      <path d="M132.384573,120.138402 C131.087204,119.413282 129.591866,119 128,119 C126.408134,119 124.912796,119.413282 123.615427,120.138402 L128,114 L132.384573,120.138402 Z" id="Combined-Shape" fill="#C12D39"></path>
                  </g>
              </g>
          </g>
      </svg>`
    }
  },
  computed: {
    ...mapState(["info"]),
    cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    },
    color(){
      return this.info.color;
    }
  },
  watch: {
    color(){
      this.pin = `<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <desc>Created with Sketch.</desc>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-737.000000, -165.000000)">
                      <g id="pin" transform="translate(737.000000, 165.000000)">
                          <circle id="dot" fill="#${this.info.color}" cx="12" cy="12" r="12"></circle>
                          <circle id="center" fill="#FFFFFF" cx="12" cy="12" r="4"></circle>
                      </g>
                  </g>
              </g>
          </svg>`;
          this.markers.forEach(marker => {
            marker.setIcon({
              anchor: new google.maps.Point(16, 16),
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(this.pin)
            })
          })
      this.bigPin = `<svg width="60px" height="74px" viewBox="0 0 60 74" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>pin</title>
              <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="index/detection" transform="translate(-838.000000, -335.000000)">
                      <g id="pin" transform="translate(838.000000, 335.000000)">
                          <path d="M38,59.0549288 C33.5000495,59.5523731 30,63.3674463 30,68 C30,63.3674463 26.4999505,59.5523731 22,59.0549288 L22,59 L22.2899933,59 C9.45748002,55.5972106 0,43.9030617 0,30 C0,13.4314575 13.4314575,0 30,0 C46.5685425,0 60,13.4314575 60,30 C60,43.9030617 50.54252,55.5972106 37.7100067,59 L38,59 L38,59.0549288 Z M30,74 C28.3431458,74 27,72.6568542 27,71 C27,69.3431458 28.3431458,68 30,68 C31.6568542,68 33,69.3431458 33,71 C33,72.6568542 31.6568542,74 30,74 Z" id="bg" fill="#${this.info.color}"></path>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" width="20px" height="24px" x="20" y="20">
                              <path d="M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z" fill="#FFFFFF"/>
                          </svg>
                      </g>
                  </g>
              </g>
          </svg>`;
      this.currentPin = `<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>current</title>
          <desc>Created with Sketch.</desc>
          <defs>
              <circle id="path-1" cx="128" cy="128" r="11"></circle>
              <filter x="-72.7%" y="-72.7%" width="245.5%" height="245.5%" filterUnits="objectBoundingBox" id="filter-2">
                  <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
          </defs>
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="index/detection" transform="translate(-886.000000, -428.000000)">
                  <g id="current" transform="translate(780.000000, 322.000000)">
                      <g id="Oval-Copy-2">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <circle stroke-opacity="0.05" stroke="#000000" stroke-width="1" fill-opacity="0.82" fill="#F8F8F8" fill-rule="evenodd" cx="128" cy="128" r="11.5"></circle>
                      </g>
                      <circle id="Oval-Copy" fill="#${this.info.color}" cx="128" cy="128" r="7"></circle>
                      <path d="M132.384573,120.138402 C131.087204,119.413282 129.591866,119 128,119 C126.408134,119 124.912796,119.413282 123.615427,120.138402 L128,114 L132.384573,120.138402 Z" id="Combined-Shape" fill="#${this.info.color}"></path>
                  </g>
              </g>
          </g>
      </svg>`;
    }
  },
  methods: {
    searchEnter() {
      if (this.search) {
          this.isSearched = true;
          this.searchedRestaurants = [];
          let initialData = this.restaurants;
          let searchParts = this.search.split(" ");
          searchParts.forEach(part => {
            initialData = this.searchByPart(initialData, part);
          });
          this.searchedRestaurants = initialData;
      } else {
        this.isSearched = false;
        this.searchedRestaurants = [];
      }
    },
    searchByPart(array, part) {
      part = part.toLowerCase()
      array = array.filter(
        element =>
          element.name.toLowerCase().includes(part) ||
          element.streetaddress.toLowerCase().includes(part) ||
          element.zip.toLowerCase().includes(part)
      );
      return array;
    },
    geolocation(){
      let thisRef = this;
      if (navigator.geolocation && this.isNearby) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          thisRef.map.setCenter(pos);
          thisRef.locationIsDisabled = false;

          //for tests
          pos.lat = 40.7442217;
          pos.long = -73.999678;

          axios.get("https://secure-badlands-41449.herokuapp.com/restaurants/near?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP",{
            params: {
              lat: pos.lat,
              long: pos.long,
              radius: 1, //ask about radius in miles
              limit: 30
            },
            headers: { "Access-Control-Allow-Origin": "*" },
            crossdomain: true
          }).then(function(response){
            thisRef.nearbyRestaurants = response.data.restaurants;
          }).catch(function(error) {
            console.log(error);
          });
          // thisRef.currentMarker = new google.maps.Marker({
          //   position: { lat: pos.lat, lng: pos.lng },
          //   map: thisRef.map,
          //   icon: {
          //     anchor: new google.maps.Point(16, 16),
          //     url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.currentPin)
          //   }
          // });
          // thisRef.currentCircle = new google.maps.Circle({
          //   strokeColor: "#" + thisRef.info.color,
          //   strokeOpacity: 0.8,
          //   strokeWeight: 2,
          //   fillColor: "#" + thisRef.info.color,
          //   fillOpacity: 0.35,
          //   map: thisRef.map,
          //   center: pos,
          //   radius: 500
          // });
        }, function(error){
          thisRef.locationIsDisabled = true;
        });
      } else {
        // thisRef.currentMarker.setVisible(false);
        // thisRef.currentCircle.setVisible(false);
        this.locationIsDisabled = true;
      }
    },
    loadData() {
      let thisRef = this;
      axios
        .get("https://secure-badlands-41449.herokuapp.com/restaurants?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", {
          headers: { "Access-Control-Allow-Origin": "*" },
          crossdomain: true
        })
        .then(function(response) {
          thisRef.restaurants = response.data.restaurants;
          //thisRef.viewedData = thisRef.data;
          thisRef.myMap();
          thisRef.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          thisRef.isLoading = false;
        });
    },
    myMap() {
      let thisRef = this;
      //const scrollTo = scroller();
      var mapProp = {
        center: new google.maps.LatLng(
          this.restaurants[0].latitude,
          this.restaurants[0].longitude
        ),
        zoom: 14,
        disableDefaultUI: true
      };
      this.map = new google.maps.Map(
        document.getElementById("googleMap"),
        mapProp
      );
      this.markers = this.restaurants.map(function(element) {
        let marker = new google.maps.Marker({
          position: { lat: element.latitude, lng: element.longitude },
          map: thisRef.map,
          icon: {
              anchor: new google.maps.Point(16, 16),
              // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin
              // url: require('../assets/images/pin.png'),
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
            },
        });
        
        let options = "";
        if (element.candeliver && element.canpickup) {
          options = "Delivery and Pickup";
        } else if (element.candeliver && !element.canpickup) {
          options = "Delivery";
        } else if (!element.candeliver && element.canpickup) {
          options = "Pickup";
        }
        var contentString = `
        <div class="location-left d-flex flex-column align-items-center">
       <h1>${element.name}</h1>
       <div class="info-loc d-flex flex-row">
        <div class="description d-flex flex-column justify-content-around">
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="far fa-map-marker-alt"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>${element.streetaddress}</p>
           <p>${element.city}, ${element.state} ${element.zip}</p>
          </div>
         </div>
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="far fa-shopping-bag"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>${options}</p>
          </div>
         </div>
         <div class="d-flex flex-row">
          <div class="first-col d-flex flex-column">
           <i class="fal fa-clock"></i>
          </div>
          <div class="first-col d-flex flex-column">
           <p>Open Now</p>
          </div>
         </div>
        </div>
       </div>
       </div>
       <div class="location-right d-flex align-items-center justify-content-center" style="width:100%">
       <button class="popup-btn d-flex flex-row align-items-center justify-content-center">
        <i class="far fa-shopping-bag"></i>
        <span>Order Now</span>
      </button>
      </div>
      </div>
      </div>
      </div>
      `;
        var div = document.createElement('div');
        div.innerHTML = contentString;
        // div.style.display = "flex";
        var button = div.getElementsByTagName("button")[0];
        button.addEventListener('click', function(e){
            //thisRef.$store.commit("restaurant.set", { restaurant: element });
            thisRef.nextToOrder(element)
        })
        var infowindow = new google.maps.InfoWindow({
          content: div,
          maxWidth: 350,
          // pixelOffset: 100
        });
        //pixelOffset: new google.maps.Size(0,50),
        marker.infowindow = infowindow;
        marker.restaurantId = element.id;
        return marker;
      });
      this.markers.forEach(marker => {
        marker.addListener("click", function() {
          thisRef.markers.forEach(m => {
            m.infowindow.close();
            // m.setIcon(require("../assets/images/pin.png"));
            m.setIcon({
              anchor: new google.maps.Point(16, 16),
              // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin,
              url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
            });
          });
          marker.infowindow.open(thisRef.map, marker);
          // marker.setIcon(require("../assets/images/pinactive.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.bigPin,
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.bigPin)
          });
          thisRef.activeId = marker.restaurantId;
          //scrollTo("#id" + thisRef.activeId);
        });
      });
    },
    zoomMarker(restaurant){
      //zoom to marker in map
      let thisRef = this;
      var center = new google.maps.LatLng(
        restaurant.latitude,
        restaurant.longitude
      );
      // using global variable:
      this.map.panTo(center);
      this.markers.forEach(marker => {
        if (
          restaurant.latitude == marker.getPosition().lat() &&
          restaurant.longitude ==
            Number(
              marker
                .getPosition()
                .lng()
                .toFixed(7)
            )
        ) {
          // marker.setIcon(require("../assets/images/pinactive.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.bigPin
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.bigPin)
          });
          marker.infowindow.open(this.map, marker);
        } else {
          // marker.setIcon(require("../assets/images/pin.png"));
          marker.setIcon({
            anchor: new google.maps.Point(16, 16),
            // url: 'data:image/svg+xml;utf-8, ' + thisRef.pin
            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(thisRef.pin)
          });
          marker.infowindow.close();
        }
      });
    },
    async nextToOrder(restaurant){
      var thisRef = this
      //save restaurant to store
      this.$store.commit("restaurant.set", { restaurant });
      this.$router.push({ name: 'order'})
      try{
        //create bucket
        var basket = await axios.post("https://secure-badlands-41449.herokuapp.com/baskets/create?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", {
          "vendorid": restaurant.id
        }).then(basket => basket.data);
        this.$store.commit("basket.set", { basket });
        //save delivery type, address if needed and delivery time and date
        if(this.info.method === 'delivery' && this.info.savedDeliveryAddresses[this.info.choosedAddressIndex]){
          let address = this.info.savedDeliveryAddresses[this.info.choosedAddressIndex];
          if(restaurant.supportsdispatch){
              basket = await axios.put("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/dispatchaddress?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", this.info.savedDeliveryAddresses[this.info.choosedAddressIndex])
              .then(response => response.data)
          }else if(restaurant.candeliver){
              basket = await axios.put("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/deliveryaddress?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", this.info.savedDeliveryAddresses[this.info.choosedAddressIndex])
              .then(response => response.data)
          }
        }
        else{
            basket = await axios.put("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/deliverymode?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", { "deliverymode": this.choosedMethod})
            .then(response => response.data)
        }
        if(this.info.when !== "asap" && this.info.deliveryDate){
            basket = await axios.put("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/timewanted?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", 
            {ismanualfire: false, year: thisRef.info.deliveryDate.year, month: thisRef.info.deliveryDate.month, day: thisRef.info.deliveryDate.day, hour: thisRef.info.deliveryDate.hour, minute: thisRef.info.deliveryDate.minute})
            .then(response => response.data)
        }
        else if(this.info.when === "asap" && this.info.basket.timemode !== "asap"){
            basket = await axios.delete("https://secure-badlands-41449.herokuapp.com/baskets/" + this.info.basket.id + "/timewanted?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP")
            .then(response => response.data)
        }
        this.$store.commit("basket.set", { basket });
        this.$router.push({ name: 'order'})
      }catch(error){
        console.log(error)
        if(error.response.data.message){
            thisRef.$refs.alert.message = error.response.data.message;
            thisRef.$refs.alert.show();
        }
      }
    }
  },
  created(){

  },
  mounted(){
    this.loadData();
  }
};
</script>
<style scoped>

.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.down-block-location{
  padding-top: 148px;
}
.down-block{
  width: 85%;
}
.down-block i{
 
	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 48px;
	font-weight: 300;
  text-align: center;
	line-height: 48px;
}
.down-block h1{
  
	width: 464px;
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
	text-align: center;
  padding-top: 24px;

}
.down-block span{
 
padding-top: 8xp;
	width: 464px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
.down-block button{
  margin-top:32px;
	height: 48px;
	width: 201px;
	border-radius: 24px;
	background-color: var(--main-color);
 
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
}



.buttons-location{
  padding-top: 31px;
}
.buttons-location button{
  padding: 20px;
	height: 118px;
	width: 232px;
	border-radius: 8px;
	/* background-color: rgba(0,0,0,0.6); */
}
.buttons-location button i{
  
	/* color: #FFFFFF; */
	font-family: "Font Awesome 5 Pro";
	font-size: 20px;
	line-height: 21px;
	text-align: center;
}
.buttons-location button h1{
  
	/* color: #FFFFFF; */
	font-family: Poppins;
	font-size: 15px;
	font-weight: bold;
	line-height: 23px;
  width: 156px;
  text-align: left;

}
.buttons-location button span{
  width: 156px;
	opacity: 0.8;
	/* color: #FFFFFF; */
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
  opacity: 0.8;
  text-align: left;
}
.buttons-location button:last-child{
  background:none;
}
.buttons-location button:last-child i{
  color: #000000;
}
.buttons-location button:last-child h1{
  color: #000000;
}
.buttons-location button:last-child span{
  color: #000000;
  opacity: 0.6;
}


input{
  outline:none;
  background:none;
  border:none;
}
button{
  outline: none;
  background: none;
  border:none;
}
.main {
    width: 100%;
    height: 100%;;
}
.search-block {
   width:100%;
   /* overflow-y: scroll !important; */
   height: auto;
   padding-top:46px;
   background-color: #FAFAFA;
}
.search{
 
	height: 62px;
	width: 466px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 30px;
	background-color: #FFFFFF;
  padding:20px;
}
.search i{
 
	opacity: 0.3;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 18px;
	line-height: 18px;
}

.search input::placeholder{

	height: 23px;
	/* width: 179px; */
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 25px;

}
.search input{
  padding-left: 12px;
	height: 23px;
	width: 100%;
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 25px;

}

.map-block {
  transition:2s ease all;
    width:100%;
    height: 100%;
background-color: rgba(0,0,0,0.1);
}
.container-maps {
  position: fixed;
  height: 100%;
  width: 100%;
}
.container-maps {
  height: 100%;
  width: 100%;
  z-index: 4;
  top: 130px;
}
.googleMaps {
  height: 100%;
  width: 100%;
  right: 0px;
  z-index: 8;
  position: fixed;
}
.active{
	background-color: var(--main-color) !important;
}
.active i{
color:#FFFFFF !important;
}
.active h1{
  color: #FFFFFF !important
}
.active span{
  color:#FFFFFF !important
}

</style>



// WEBPACK FOOTER //
// src/components/steps/search.vue